import React, { useEffect, useState } from "react"
import { Card } from "react-bootstrap"
import { Chip } from "@material-ui/core"
import clsx from "clsx"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { Skeleton } from "@material-ui/lab"
import { CardBody } from "../../../../../../_metronic/_partials/controls/index.js"
import { useSubheader } from "../../../../../../_metronic/layout/index.js"
import { NoteView } from "../../../../../../component/index.jsx"
import { RoutesConstants } from "../../../../../../constants/RoutesConstants.js"
import { KPI_GOAL_SETTING_TAB, UNIT_STRING } from "../../../../../../constants/StringConstant.js"
import { getKpiGoalThisYearTargetRegional, getTargetSubregionalData } from "../../../../../../redux/actions/FieldOfficerAction.jsx"
import { stringFormatting, toThousandConvert } from "../../../../../helpers/TextHelper.js"
import { useLocation, useHistory } from "react-router-dom"
import { loadUserLogin } from "../../../../../../config/index.jsx"
import { getUrlParsingPageFilter } from "../../../../../../config/EndpointCollection.js"
import TableInputForecast2 from "../../../forecast/table-input-forecast/TableInputForecast2.jsx"

export default function ForecastSubRegionalPage({
  match: {
    params: { id, year, regional}
  }
}) {
  const subheader = useSubheader()
  const dispatch = useDispatch()
  const { FieldOfficer } = useSelector((state) => state)
  const { t } = useTranslation()
  const routerHistory = useHistory()
  const location = useLocation()
  const searchParams = new URLSearchParams(location?.search)
  const history = searchParams.get("history")
  const user = loadUserLogin()
  const [isLoading, setIsLoading] = useState(true)

  const selectedMonth = searchParams.get("month") != null && searchParams.get("month") !== "" ? parseInt(searchParams.get("month")) : 0

  const handleMonthChange = (month) => {
    const urlParam = getUrlParsingPageFilter({
      month: month,
    })
    // Preserve the history param if it exists
    const params = new URLSearchParams(urlParam)
    if (history) {
      params.set("history", history)
    }
    routerHistory.push({ pathname: location.pathname, search: params.toString() })
  }


  useEffect(() => {
    if (regional && !searchParams.get("month")) {
      handleMonthChange(0)
    }
    setIsLoading(true)
    if (regional) {
      Promise.all([
        dispatch(getKpiGoalThisYearTargetRegional(year, regional)),
        dispatch(getTargetSubregionalData(id, year))
      ]).then(() => setIsLoading(false))
    }
  }, [regional, id, year])

  useEffect(() => {
    let dataBreadcrumb =
      !history
        ? // if forecast accessed from this year tab
        [
          {
            pathname: RoutesConstants.FIELD_OFFICER.KPI_GOAL_SETTING(
              regional,
              KPI_GOAL_SETTING_TAB.THIS_YEAR,
              Number(year)
            ),
            title: t("sub_header_kpi_goal_setting")
          },
          {
            title: t("dropdown_forecast")
          }
        ]
        : // if forecast accessed from history tab
        [
          {
            pathname: RoutesConstants.FIELD_OFFICER.KPI_GOAL_SETTING(
              regional,
              KPI_GOAL_SETTING_TAB.THIS_YEAR,
              Number(year)
            ),
            title: t("sub_header_kpi_goal_setting")
          },
          {
            pathname: RoutesConstants.FIELD_OFFICER.KPI_GOAL_SETTING(
              regional,
              KPI_GOAL_SETTING_TAB.HISTORY,
              Number(year)
            ),
            title: t("sub_header_kpi_goals_setting_history")
          },
          {
            pathname: RoutesConstants.FIELD_OFFICER.DETAIL_KPI_TARGET_KPI_BY_YEAR(year, regional),
            title: t("sub_header_detail_history_kpi_goal_setting", { year: year })
          },
          {
            title: t("dropdown_forecast") + " " + year
          }
        ]

    if (!user?.regional_id) {
      dataBreadcrumb.unshift({
        pathname: RoutesConstants.FIELD_OFFICER.KPI_GOAL_SETTING_INDEX(),
        title: t("sub_header_all_regional")
      })
    }
    subheader.setBreadcrumbs(dataBreadcrumb)
    subheader.setButton(null)
  }, [year, history])

  return (
    <Card>
      <CardBody>
        {isLoading ? (
          <>
            <Skeleton animation="wave" className="rounded mb-3" variant="text" height={36} width={300} />
            <Skeleton animation="wave" className="rounded mb-10" variant="text" height={24} width={200} />
            <Skeleton animation="wave" className="rounded mb-5" variant="rect" height={200} />
          </>
        ) : (
          <>
            <div className="mb-5 pb-5">
              <h2 className="font-weight-bolder text-uppercase">
                {t("label_regional")} {stringFormatting(FieldOfficer?.kpiGoalThisYearTargetRegional?.regional_name)}, {year}
              </h2>
              <span className="txt-16 font-weight-medium">
                {t("label_regional_head")}: {stringFormatting(FieldOfficer?.kpiGoalThisYearTargetRegional?.regional_head_name)}
              </span>
            </div>
            <div className="mb-5 mt-5">
              <span className="font-weight-bolder txt-16 text-uppercase">{t("label_plant_target_forecast")}</span>
              <div className="mt-2 mb-5">
                <span className="text-muted text-uppercase">
                  {t("label_sub_regional")}: {stringFormatting(FieldOfficer?.targetSubregional?.sub_regional_name)}
                </span>
              </div>
            </div>
            <table className="table-bordered w-100 mb-10">
              <thead>
                <tr>
                  <th className="py-5 px-3 bg-disabled text-uppercase">{t("label_plant_type")}</th>
                  <th className="py-5 px-3 bg-disabled text-uppercase">{t("label_planting_target_yearly")}</th>
                  <th className="py-5 px-3 bg-disabled text-uppercase">{t("label_forecast_yearly")}</th>
                </tr>
              </thead>
              <tbody>
                {(FieldOfficer?.targetSubregional?.target || []).map((cropItem) => (
                  <tr key={cropItem.id}>
                    <td className="py-3 px-3 font-weight-bolder">{stringFormatting(cropItem.plant_type_name)}</td>
                    <td className="py-3 px-3">{stringFormatting(toThousandConvert(cropItem.planting_target?.parsedValue ?? cropItem.planting_target), UNIT_STRING.HA)}</td>
                    <td className="py-3 px-3">{stringFormatting(toThousandConvert(cropItem.forecast?.parsedValue ?? cropItem.forecast), UNIT_STRING.HA)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}

        <span className="txt-16 font-weight-bolder text-uppercase">
          {t("label_forecast_detail")}
        </span>

        <div className="mb-5 mt-5">
          <div className="d-flex align-items-center">
            {[
              { label: "Jan", value: 0 },
              { label: "Feb", value: 1 },
              { label: "Mar", value: 2 },
              { label: "Apr", value: 3 },
              { label: "Mei", value: 4 },
              { label: "Jun", value: 5 },
              { label: "Jul", value: 6 },
              { label: "Agt", value: 7 },
              { label: "Sep", value: 8 },
              { label: "Okt", value: 9 },
              { label: "Nov", value: 10 },
              { label: "Des", value: 11 },
            ].map((item) => (
              <Chip
                key={item.value}
                className={clsx(
                  "chip-selected-multiple-input mr-2 cursor-pointer font-maxxi",
                  selectedMonth === item.value
                    ? "bg-tertiary-light-green text-primary-green border-primary-green"
                    : "bg-neutral-white text-neutral-gray border-neutral-gray"
                )}
                size="medium"
                label={item.label}
                onClick={() => handleMonthChange(item.value)}
                style={{
                  borderWidth: 1,
                  borderStyle: "solid",
                }}
              />
            ))}
          </div>
        </div>
        {!history && (
          <NoteView title={t("label_forecast_detail_information")} />
        )}
        <TableInputForecast2
          month={selectedMonth}
          onAfterSubmit={() => Promise.all([
            dispatch(getTargetSubregionalData(id, year)),
            dispatch(getKpiGoalThisYearTargetRegional(year, regional))
          ])}
        />
      </CardBody>
    </Card>
  )
}
